var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCamera = function SvgCamera(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.4 5.4v13.199h19.2V5.4zm18 12H3.6V6.6h16.8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 15.55A3.554 3.554 0 0 0 15.55 12 3.554 3.554 0 0 0 12 8.45 3.554 3.554 0 0 0 8.45 12 3.554 3.554 0 0 0 12 15.55m0-6c1.35 0 2.45 1.1 2.45 2.45s-1.1 2.45-2.45 2.45c-1.352 0-2.45-1.1-2.45-2.45S10.647 9.55 12 9.55",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 9.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  })));
};
export { SvgCamera as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' fill-rule='evenodd' d='M2.4 5.4v13.199h19.2V5.4zm18 12H3.6V6.6h16.8z' clip-rule='evenodd'/%3e%3cpath fill='currentColor' fill-rule='evenodd' d='M12 15.55A3.554 3.554 0 0 0 15.55 12 3.554 3.554 0 0 0 12 8.45 3.554 3.554 0 0 0 8.45 12 3.554 3.554 0 0 0 12 15.55m0-6c1.35 0 2.45 1.1 2.45 2.45s-1.1 2.45-2.45 2.45c-1.352 0-2.45-1.1-2.45-2.45S10.647 9.55 12 9.55' clip-rule='evenodd'/%3e%3cpath fill='currentColor' d='M6 9.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5'/%3e%3c/svg%3e";